import { render, staticRenderFns } from "./EntityMultiselectMultiple.vue?vue&type=template&id=153a8210&"
import script from "./EntityMultiselectMultiple.vue?vue&type=script&lang=js&"
export * from "./EntityMultiselectMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports